import apiClient from "@/services/apiClient";

export async function subscribeNewsletter(email) {
  const { data } = await apiClient.post("/public/newsletter/subscribe", { email });
  return data;
}
